// import React, { useState, useEffect, useCallback } from 'react';
// import { RiCollapseDiagonalLine } from "react-icons/ri";
// import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
// import { FaFilter } from "react-icons/fa";
// import { TbReload, TbArrowsSort } from "react-icons/tb";
// import { FaDownload } from "react-icons/fa6";

// const API_URL = process.env.REACT_APP_API_BASE|| '';

// function StatusBadge({ status }) {
//     const s = (status || '').toLowerCase();
//     const map = {
//         running:   'bg-yellow-100 text-yellow-700 border-yellow-200',
//         completed: 'bg-green-100 text-green-700 border-green-200',
//         failed:    'bg-red-100 text-red-600 border-red-200',
//         pending:   'bg-gray-100 text-gray-500 border-gray-200',
//         sent:      'bg-blue-100 text-blue-700 border-blue-200',
//         delivered: 'bg-green-100 text-green-700 border-green-200',
//         read:      'bg-purple-100 text-purple-700 border-purple-200',
//     };
//     return (
//         <span className={`px-2 py-0.5 rounded-full text-[10px] font-semibold border capitalize ${map[s] || 'bg-gray-100 text-gray-500 border-gray-200'}`}>
//             {status || '-'}
//         </span>
//     );
// }

// // Modal to show sent message and error info
// function ViewModal({ open, onClose, row }) {
//     if (!open || !row) return null;
//     const isFailed = (row.status || '').toLowerCase() === 'failed';

//     // errorCode and errorReason may come as error_code/error_reason or errorCode/errorReason
//     const errorCode = row.error_code || row.errorCode || row.error || '';
//     const errorReason = row.error_reason || row.errorReason || row.error_message || row.errorMessage || '';

//     // Support message keys: message (plain text), or payload/content structure if needed
//     // Try to cover possible server fields for sent message
//     const sentMessage = row.message
//         || row.message_body
//         || row.body
//         || (row.payload && typeof row.payload === "object" ? JSON.stringify(row.payload, null, 2) : "")
//         || "";

//     return (
//         <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex justify-center items-center">
//             <div className="bg-white rounded-lg shadow-xl max-w-md w-[95vw] p-6 relative dark:bg-[#181C23]">
//                 <button
//                     onClick={onClose}
//                     className="absolute top-2 right-2 text-gray-400 hover:text-gray-900 dark:hover:text-white"
//                     aria-label="Close"
//                 >
//                     ×
//                 </button>
//                 <h2 className="text-lg font-bold text-[#3f7fca] mb-4">Message Details</h2>

//                 <div className="mb-3">
//                     <label className="text-xs font-semibold text-gray-700 dark:text-gray-200">Sent Message:</label>
//                     <div className="text-[13px] border border-gray-200 rounded px-2 py-1 mt-1 bg-gray-50 dark:bg-[#181C23] dark:text-white font-mono whitespace-pre-line"
//                         style={{ wordBreak: 'break-all', maxHeight: 180, overflowY: 'auto'}}>
//                         {sentMessage ? sentMessage : <span className="text-gray-400">No message content found.</span>}
//                     </div>
//                 </div>
//                 {isFailed && (
//                     <div className="mt-2">
//                         <label className="block text-xs font-semibold text-red-600 mb-1">Error Details:</label>
//                         <div className="rounded bg-red-50 border border-red-200 px-3 py-2 text-[13px] text-red-700 leading-snug dark:bg-[#23161d] dark:text-red-400 dark:border-red-700">
//                             <div>
//                                 <span className="font-semibold">Error Code:</span> <span>{errorCode || '-'}</span>
//                             </div>
//                             <div>
//                                 <span className="font-semibold">Reason:</span> {errorReason ? <span>{errorReason}</span> : <span>-</span>}
//                             </div>
//                         </div>
//                     </div>
//                 )}
//                 {!isFailed && !sentMessage && (
//                     <div className="text-gray-400 text-sm">No additional info available.</div>
//                 )}
//             </div>
//         </div>
//     );
// }

// function DeliveryReport() {
//     const [showfilter, setshowfilter] = useState(false);
//     const [NumberFilter, setNumberFilter]     = useState('');
//     const [TemplateType, setTemplateType]     = useState('');
//     const [DeliveryStatus, setDeliveryStatus] = useState('');

//     const [allData, setAllData]   = useState([]);  // all campaign messages flat
//     const [filtered, setFiltered] = useState([]);
//     const [loading, setLoading]   = useState(false);
//     const [error, setError]       = useState('');

//     const [currentPage, setcurrentPage] = useState(1);
//     const [usersPerPage, setUsersPerPage] = useState(10); // entries per page, default 10
//     // keeping names "usersPerPage", but it's really records/messages per page

//     // recompute page indices based on usersPerPage
//     const indexoflastuser  = currentPage * usersPerPage;
//     const indexoffirstuser = indexoflastuser - usersPerPage;
//     const filteruser       = filtered.slice(indexoffirstuser, indexoflastuser);
//     const totalpages       = Math.ceil(filtered.length / usersPerPage);

//     // Modal for view action
//     const [modalRow, setModalRow] = useState(null);
//     const [isModalOpen, setIsModalOpen] = useState(false);

//     const openModal = (row) => {
//         setModalRow(row);
//         setIsModalOpen(true);
//     };
//     const closeModal = () => {
//         setModalRow(null);
//         setIsModalOpen(false);
//     };

//     // ── Fetch all campaigns, then fetch messages for each ─────────────────────
//     const fetchData = useCallback(async () => {
//         setLoading(true);
//         setError('');
//         try {
//             const res  = await fetch(`${API_URL}/auth/campaign/report`, { credentials: 'include' });
//             const json = await res.json();
//             if (!json.success) throw new Error('Failed to load campaigns');

//             const campaigns = json.data || [];

//             // Fetch messages for every campaign in parallel
//             const allMessages = await Promise.all(
//                 campaigns.map(async (c) => {
//                     try {
//                         const r    = await fetch(`${API_URL}/auth/campaign/${c.id}`, { credentials: 'include' });
//                         const data = await r.json();
//                         return (data.data || []).map(msg => ({
//                             ...msg,
//                             campaign_name:  c.campaign_name,
//                             template_name:  c.template_name,
//                             template_type:  c.template_type,
//                             interface_type: c.interface,
//                             campaign_created_at: c.created_at,
//                         }));
//                     } catch { return []; }
//                 })
//             );

//             const flat = allMessages.flat();
//             setAllData(flat);
//             setFiltered(flat);
//         } catch (e) {
//             setError('Failed to load delivery data.');
//             console.error(e);
//         } finally {
//             setLoading(false);
//         }
//     }, []);

//     useEffect(() => { fetchData(); }, [fetchData]);

//     // ── Filter ────────────────────────────────────────────────────────────────
//     const applyFilter = () => {
//         let d = [...allData];
//         if (NumberFilter)   d = d.filter(r => (r.phone_number || '').includes(NumberFilter));
//         if (TemplateType)   d = d.filter(r => (r.template_type || '').toLowerCase() === TemplateType.toLowerCase());
//         if (DeliveryStatus) d = d.filter(r => (r.status || '').toLowerCase().includes(DeliveryStatus.toLowerCase()));
//         setFiltered(d);
//         setcurrentPage(1);
//     };

//     const clearFilter = () => {
//         setNumberFilter(''); setTemplateType(''); setDeliveryStatus('');
//         setFiltered(allData);
//         setcurrentPage(1);
//     };

//     // ── CSV Download ──────────────────────────────────────────────────────────
//     const handleDownload = () => {
//         const headers = [
//             'Received Date', 'Channel', 'Number', 'Status', 'Campaign',
//             'Template', 'Template Type', 'Interface', 'Error Code', 'Error Reason', 'Message'
//         ];
//         const rows = filtered.map(r => [
//             r.campaign_created_at ? new Date(r.campaign_created_at).toLocaleString() : '',
//             'WhatsApp',
//             r.phone_number || '',
//             r.status || '',
//             r.campaign_name || '',
//             r.template_name || '',
//             r.template_type || '',
//             r.interface_type || '',
//             r.error_code || r.errorCode || r.error || '',
//             r.error_reason || r.errorReason || r.error_message || r.errorMessage || '',
//             (r.message || r.message_body || r.body || (r.payload && typeof r.payload === "object" ? JSON.stringify(r.payload, null, 2) : "") || '').replace(/"/g, '""'),
//         ]);
//         const csv = [headers, ...rows].map(row => row.map(v => `"${v ?? ''}"`).join(',')).join('\n');
//         const blob = new Blob([csv], { type: 'text/csv' });
//         const a    = document.createElement('a');
//         a.href     = URL.createObjectURL(blob);
//         a.download = 'delivery_report.csv';
//         a.click();
//     };

//     const columns = [
//         'Received Date', 'Channel', 'Number', 'Status', 'Campaign',
//         'Template Name', 'Interface / Type', 'Cost', 'Error Details', 'Action'
//     ];

//     // Handler to change entries per page
//     const handleUsersPerPageChange = e => {
//         const val = parseInt(e.target.value, 10);
//         setUsersPerPage(val);
//         setcurrentPage(1);
//     };

//     return (
//         <>
//             {/* Modals */}
//             <ViewModal open={isModalOpen} onClose={closeModal} row={modalRow} />

//             {/* Top bar */}
//             <div className='w-full flex items-center justify-between mb-2'>
//                 <p className='text-[12px] text-gray-500 dark:text-gray-400'>
//                     Total: <span className='font-bold text-[#37715d]'>{allData.length}</span> messages
//                 </p>
//                 <div className='flex gap-2'>
//                     <button
//                         onClick={fetchData}
//                         className='flex items-center justify-center border border-[#37715d] rounded-lg p-2 text-[#37715d] gap-1 hover:bg-[#37715d] hover:text-white transition-colors'
//                     >
//                         <TbReload className='text-[13px]' />
//                         <span className='text-[12px] font-bold'>Refresh</span>
//                     </button>
//                     <button
//                         onClick={handleDownload}
//                         className='flex items-center justify-center border border-[#3f7fca] rounded-lg p-2 text-[#3f7fca] gap-1 hover:bg-[#3f7fca] hover:text-white transition-colors'
//                     >
//                         <FaDownload className='text-[12px]' />
//                         <span className='text-[12px] font-bold'>Download</span>
//                     </button>
//                 </div>
//             </div>

//             {/* Filter Bar */}
//             <div
//                 onClick={() => setshowfilter(!showfilter)}
//                 className='w-full flex justify-between px-4 py-2 bg-[#e0e0e04b] rounded-t-[20px] cursor-pointer'
//             >
//                 <div className='flex items-center text-[#576071] font-semibold gap-3 dark:text-white'>
//                     <RiCollapseDiagonalLine /> Filter Records
//                 </div>
//                 <div className='flex items-center text-[#576071] dark:text-white'>
//                     {showfilter ? <IoIosArrowDown /> : <IoIosArrowUp />}
//                 </div>
//             </div>

//             {showfilter && (
//                 <div className='bg-[#edf1f5] py-2 px-4 w-full dark:bg-[#121519] z-20'>
//                     <div className='w-full flex flex-wrap gap-2'>
//                         <div className='w-full sm:w-[48%] lg:w-[19%] flex flex-col gap-1'>
//                             <label className='text-[#000] text-[12px] font-semibold dark:text-white'>Number</label>
//                             <input
//                                 value={NumberFilter}
//                                 onChange={e => setNumberFilter(e.target.value)}
//                                 className='text-[#454546] border-[#d4cfcf] border rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-white'
//                                 type="text" placeholder="+91..."
//                             />
//                         </div>

//                         <div className='w-full sm:w-[48%] lg:w-[19%] flex flex-col gap-1'>
//                             <label className='text-[#000] text-[12px] font-semibold dark:text-white'>Template Type</label>
//                             <select
//                                 value={TemplateType}
//                                 onChange={e => setTemplateType(e.target.value)}
//                                 className='text-[#454546] border-[#d4cfcf] border rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-white'
//                             >
//                                 <option value="">Select Template Type</option>
//                                 <option value="marketing">Marketing</option>
//                                 <option value="utility">Utility</option>
//                                 <option value="authentication">Authentication</option>
//                             </select>
//                         </div>

//                         <div className='w-full sm:w-[48%] lg:w-[19%] flex flex-col gap-1'>
//                             <label className='text-[#000] text-[12px] font-semibold dark:text-white'>Delivery Status</label>
//                             <select
//                                 value={DeliveryStatus}
//                                 onChange={e => setDeliveryStatus(e.target.value)}
//                                 className='text-[#454546] border-[#d4cfcf] border rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-white'
//                             >
//                                 <option value="">All Status</option>
//                                 <option value="pending">Pending</option>
//                                 <option value="sent">Sent</option>
//                                 <option value="delivered">Delivered</option>
//                                 <option value="read">Read</option>
//                                 <option value="failed">Failed</option>
//                             </select>
//                         </div>

//                         <div className='w-full sm:w-[48%] lg:w-[19%] flex items-center gap-1 mt-4'>
//                             <button onClick={applyFilter} className='flex items-center justify-center border border-[#37715d] rounded-lg p-2 text-[#37715d] gap-2 hover:bg-[#37715d] hover:text-white w-full sm:w-auto transition-colors'>
//                                 <FaFilter /><span className='text-[12px] font-bold'>Filter</span>
//                             </button>
//                             <button onClick={clearFilter} className='flex items-center justify-center border border-[#3f7fca] rounded-lg p-2 text-[#3f7fca] gap-2 hover:bg-[#3f7fca] hover:text-white w-full sm:w-auto transition-colors'>
//                                 <TbReload /><span className='text-[12px] font-bold'>Clear Filter</span>
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {/* Error */}
//             {error && (
//                 <div className='w-full bg-red-50 border border-red-200 text-red-600 text-[12px] px-4 py-2 rounded my-2'>
//                     {error}
//                 </div>
//             )}

//             {/* Table */}
//             <div className='overflow-x-auto'>
//                 <table className="w-full overflow-hidden border border-[#dee2e6]">
//                     <thead>
//                         <tr className="text-left">
//                             {columns.map(col => (
//                                 <th key={col} className="p-1 cursor-pointer border border-[#dee2e6] bg-[#f6f9fc] dark:bg-[#1a1f24]">
//                                     <div className="flex justify-between items-center gap-2">
//                                         <span className='text-[11px] text-[#576071] dark:text-white font-semibold'>{col}</span>
//                                         {col !== 'Action' && (
//                                             <button type="button" className="text-gray-400 hover:text-black"><TbArrowsSort /></button>
//                                         )}
//                                     </div>
//                                 </th>
//                             ))}
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {loading ? (
//                             <tr className="bg-[#f6f9fc] dark:bg-[#121519]">
//                                 <td colSpan={columns.length} className="py-8 text-center">
//                                     <div className="flex items-center justify-center gap-2 text-[12px] text-gray-400">
//                                         <div className="w-4 h-4 border-2 border-[#37715d] border-t-transparent rounded-full animate-spin" />
//                                         Loading delivery data...
//                                     </div>
//                                 </td>
//                             </tr>
//                         ) : filteruser.length === 0 ? (
//                             <tr className="text-center bg-[#f6f9fc] dark:bg-[#121519]">
//                                 <td colSpan={columns.length} className="py-8 text-[12px] text-gray-400">No data found</td>
//                             </tr>
//                         ) : (
//                             filteruser.map((row, i) => {
//                                 // Find error code and reason if status is failed
//                                 const isFailed = (row.status || '').toLowerCase() === 'failed';
//                                 const errorCode = row.error_code || row.errorCode || row.error || '';
//                                 const errorReason = row.error_reason || row.errorReason || row.error_message || row.errorMessage || '';

//                                 return (
//                                     <tr
//                                         key={row.id || i}
//                                         className="text-gray-500 odd:bg-white even:bg-[#edf1f5] dark:odd:bg-[#121519] dark:even:bg-[#1a1f24] hover:bg-[#e8f0fa] dark:hover:bg-[#2a2f35] transition-colors"
//                                     >
//                                         <td className="p-1 text-[11px] border border-[#dee2e6] dark:text-white text-gray-400">
//                                             {row.campaign_created_at ? new Date(row.campaign_created_at).toLocaleString() : '-'}
//                                         </td>
//                                         <td className="p-1 text-[11px] border border-[#dee2e6] dark:text-white">
//                                             <span className='flex items-center gap-1'>
//                                                 <span className='w-2 h-2 rounded-full bg-green-500 inline-block'></span>
//                                                 WhatsApp
//                                             </span>
//                                         </td>
//                                         <td className="p-1 text-[11px] border border-[#dee2e6] dark:text-white font-mono">
//                                             {row.phone_number || '-'}
//                                         </td>
//                                         <td className="p-1 text-[11px] border border-[#dee2e6]">
//                                             <StatusBadge status={row.status} />
//                                         </td>
//                                         <td className="p-1 text-[11px] border border-[#dee2e6] dark:text-white">
//                                             {row.campaign_name || '-'}
//                                         </td>
//                                         <td className="p-1 text-[11px] border border-[#dee2e6] dark:text-white">
//                                             {row.template_name || '-'}
//                                             {row.template_type && (
//                                                 <span className='ml-1 text-[9px] text-gray-400 capitalize'>({row.template_type})</span>
//                                             )}
//                                         </td>
//                                         <td className="p-1 text-[11px] border border-[#dee2e6] dark:text-white capitalize">
//                                             {row.interface_type || 'web'}
//                                         </td>
//                                         <td className="p-1 text-[11px] border border-[#dee2e6] dark:text-white">-</td>
//                                         <td className="p-1 text-[11px] border border-[#dee2e6] dark:text-white">
//                                             {isFailed ? (
//                                                 <div className='text-red-500 text-[10px]'>
//                                                     <div><span className="font-semibold">Code:</span> {errorCode || '-'}</div>
//                                                     <div><span className="font-semibold">Reason:</span> {errorReason || '-'}</div>
//                                                 </div>
//                                             ) : '-'}
//                                         </td>
//                                         <td className="p-1 text-[11px] border border-[#dee2e6]">
//                                             <button
//                                                 className='text-[#3f7fca] hover:underline text-[10px] font-semibold'
//                                                 onClick={() => openModal(row)}
//                                             >View</button>
//                                         </td>
//                                     </tr>
//                                 );
//                             })
//                         )}
//                     </tbody>
//                 </table>
//             </div>

//             {/* Pagination with entries selector */}
//             <div className='flex flex-col md:flex-row md:justify-between w-full mt-2 gap-2'>
//                 <div className='flex items-center mt-2 space-x-2'>
//                     <label className="text-[11px] text-[#3f7fc8]">
//                         Show
//                         <select
//                             className="mx-1 px-1 py-0.5 border border-gray-300 rounded text-[11px] outline-none"
//                             style={{ minWidth: 52 }}
//                             value={usersPerPage}
//                             onChange={handleUsersPerPageChange}
//                         >
//                             <option value={10}>10</option>
//                             <option value={20}>20</option>
//                             <option value={50}>50</option>
//                             <option value={100}>100</option>
//                         </select>
//                         entries
//                     </label>
//                 </div>
//                 <p className='text-[11px] text-[#3f7fc8] mt-2'>
//                     Showing {filtered.length === 0 ? 0 : indexoffirstuser + 1} to {Math.min(indexoflastuser, filtered.length)} of {filtered.length} records
//                 </p>
//                 <div className="flex items-center mt-2 space-x-2">
//                     <button
//                         disabled={currentPage === 1}
//                         onClick={() => setcurrentPage(p => p - 1)}
//                         className="px-3 py-1 text-[11px] bg-gray-200 rounded disabled:opacity-50 hover:bg-gray-300 transition"
//                     >Prev</button>
//                     <p className='text-[11px] text-[#3f7fc8]'>{currentPage} page of {totalpages || 1} pages</p>
//                     <button
//                         disabled={currentPage >= totalpages}
//                         onClick={() => setcurrentPage(p => p + 1)}
//                         className="px-3 py-1 text-[11px] bg-gray-200 rounded disabled:opacity-50 hover:bg-gray-300 transition"
//                     >Next</button>
//                 </div>
//             </div>
//         </>
//     );
// }

// export default DeliveryReport;
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { RiCollapseDiagonalLine } from 'react-icons/ri';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';
import { FaFilter, FaDownload } from 'react-icons/fa';
import { TbReload, TbArrowsSort } from 'react-icons/tb';

const API_URL = process.env.REACT_APP_API_BASE || '';
const WABA_ID = '970067979034513';

// ── Token helpers ──────────────────────────────────────────────────────────
function decodeToken(token) {
    if (!token) return {};
    try {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
            atob(base64).split('').map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join('')
        );
        return JSON.parse(jsonPayload);
    } catch { return {}; }
}

function getUserIdFromToken() {
    if (typeof window !== 'undefined' && typeof window.locatorgarsotrga === 'function') {
        const rawToken = window.locatorgarsotrga('token');
        if (rawToken) {
            const decoded = decodeToken(rawToken);
            return { userId: decoded.id || decoded.userId || decoded._id, token: rawToken };
        }
    }
    const rawToken = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
    if (rawToken) {
        const decoded = decodeToken(rawToken);
        return { userId: decoded.id || decoded.userId || decoded._id, token: rawToken };
    }
    return { userId: null, token: null };
}

// ── Helpers ────────────────────────────────────────────────────────────────
function fmtDt(dt) {
    if (!dt) return 'N/A';
    return new Date(dt).toLocaleString('en-IN', {
        day: '2-digit', month: '2-digit', year: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true,
    });
}

function formatCost(val) {
    if (val == null || val === '' || val === '-') return '-';
    const n = Number(val);
    return isNaN(n) ? '-' : `${n.toFixed(3)}`;
}

function formatPhone(raw) {
    if (!raw) return '-';
    const s = String(raw).trim();
    return s.startsWith('+') ? s : `+${s}`;
}

// ── Status Badge ───────────────────────────────────────────────────────────
function StatusBadge({ status }) {
    const s = (status || '').toLowerCase();
    const map = {
        running:   'bg-yellow-100 text-yellow-700 border-yellow-200',
        completed: 'bg-green-100  text-green-700  border-green-200',
        failed:    'bg-red-100    text-red-600    border-red-200',
        pending:   'bg-gray-100   text-gray-500   border-gray-200',
        sent:      'bg-blue-100   text-blue-700   border-blue-200',
        delivered: 'bg-green-100  text-green-700  border-green-200',
        read:      'bg-purple-100 text-purple-700 border-purple-200',
    };
    return (
        <span className={`px-2 py-0.5 rounded-full text-[10px] font-semibold border capitalize ${map[s] || 'bg-gray-100 text-gray-500 border-gray-200'}`}>
            {status || '-'}
        </span>
    );
}

// ── Mobile Preview Offcanvas ───────────────────────────────────────────────
function MobilePreviewOffcanvas({ open, onClose, row, templates, previewLoading }) {
    if (!open || !row) return null;

    const status      = (row.status || '').toLowerCase();
    const isFailed    = status === 'failed';
    const errorCode   = row.error_code || row.errorCode || row.error || '-';
    const errorReason = row.error_reason || row.errorReason || row.error_message || '-';

    const sentOn     = row.sent_at
        ? fmtDt(row.sent_at)
        : (status !== 'pending' ? fmtDt(row.created_at) : 'N/A');
    const deliveryOn = row.delivered_at
        ? fmtDt(row.delivered_at)
        : (['delivered', 'read'].includes(status) ? fmtDt(row.updated_at || row.created_at) : 'N/A');
    const readOn     = row.read_at
        ? fmtDt(row.read_at)
        : (status === 'read' ? fmtDt(row.updated_at || row.created_at) : 'N/A');

    let bodyText    = '';
    let footerText  = '';
    let headerMedia = null;
    let buttons     = [];

    let parsedTemplateName = row.template_name || '';
    let parsedVariables    = row.variables || [];
    if (!parsedTemplateName && row.content) {
        try {
            const c = typeof row.content === 'string' ? JSON.parse(row.content) : row.content;
            parsedTemplateName = c.name || '';
            const bodyComp = (c.components || []).find(x => x.type === 'body');
            if (bodyComp) {
                parsedVariables = (bodyComp.parameters || []).map(p => p.text || '');
            }
        } catch { /* ignore */ }
    }

    const tmpl = templates.find(t =>
        (t.name || '').toLowerCase() === (parsedTemplateName || '').toLowerCase()
    );

    if (tmpl) {
        (tmpl.components || []).forEach(c => {
            if (c.type === 'BODY')                           bodyText    = c.text || '';
            if (c.type === 'FOOTER')                         footerText  = c.text || '';
            if (c.type === 'HEADER' && c.format !== 'TEXT') headerMedia = { format: c.format };
            if (c.type === 'BUTTONS')                        buttons     = c.buttons || [];
        });
        const vars = Array.isArray(parsedVariables)
            ? parsedVariables
            : (parsedVariables ? Object.values(parsedVariables) : []);
        vars.forEach((v, i) => { bodyText = bodyText.replace(`{{${i + 1}}}`, v); });
    } else {
        bodyText = row.message || row.message_body || row.body || '(No message content)';
    }

    const tickColor = status === 'read' ? '#34B7F1' : '#aaa';

    // Per-message cost (fetched and attached during enrichment)
    const msgCost = row.message_cost;

    return (
        <>
            <div className="fixed inset-0 bg-black bg-opacity-50 z-[1040]" onClick={onClose} />
            <div className="fixed top-0 right-0 w-[420px] max-w-full h-full bg-white dark:bg-[#181C23] z-[1050] flex flex-col shadow-2xl">

                {/* Header */}
                <div className="flex justify-between items-center px-5 py-4 border-b border-gray-200 dark:border-gray-700">
                    <h5 className="text-[15px] font-bold dark:text-white">Mobile Preview</h5>
                    <button onClick={onClose} className="text-gray-400 hover:text-gray-800 dark:hover:text-white text-xl bg-transparent border-none cursor-pointer">&times;</button>
                </div>

                {/* Body */}
                <div className="flex-1 overflow-y-auto p-4 flex justify-center">
                    {previewLoading ? (
                        <div className="flex flex-col items-center justify-center h-40 gap-3 text-gray-400 text-[13px]">
                            <div className="w-5 h-5 border-2 border-[#37715d] border-t-transparent rounded-full animate-spin" />
                            Loading preview...
                        </div>
                    ) : (
                        <div className="w-full">

                            {/* Acknowledgement */}
                            <div className="bg-[#f9f9f9] dark:bg-[#1a1f24] rounded-lg border-l-4 border-[#00816a] p-3 mb-3 text-[11.5px] text-gray-600 dark:text-gray-300">
                                <div className="font-bold mb-1 text-gray-800 dark:text-white">Acknowledgement</div>
                                <div>📤 <strong>Sent On:</strong> {sentOn}</div>
                                <div>📬 <strong>Delivery On:</strong> {deliveryOn}</div>
                                <div>👁️ <strong>Read On:</strong> {readOn}</div>
                            </div>

                            {/* Message meta */}
                            <div className="bg-[#f0f7ff] dark:bg-[#1a1f24] rounded-lg border-l-4 border-[#3f7fca] p-3 mb-3 text-[11px] text-gray-600 dark:text-gray-300">
                                <div className="font-bold mb-1 text-gray-800 dark:text-white">Message Details</div>
                                <div><strong>Campaign ID:</strong> {row.campaign_id || '-'}</div>
                                <div><strong>Campaign Name:</strong> {row.campaign_name || '-'}</div>
                                <div><strong>Template:</strong> {parsedTemplateName || '-'} <span className="capitalize">({row.template_type || '-'})</span></div>
                                <div><strong>Interface:</strong> {row.interface_type || 'Web'}</div>
                                <div><strong>WABA ID:</strong> {row.waba_id || WABA_ID}</div>

                                {/* Per-message cost */}
                                <div className="mt-2 pt-2 border-t border-blue-100">
                                    <div className="font-semibold mb-1 text-gray-700 dark:text-gray-200">Message Cost</div>
                                    <div className="flex flex-wrap gap-1">
                                        <span className="px-2 py-0.5 rounded-full bg-blue-50 text-blue-600 border border-blue-200 font-semibold text-[10px]">
                                            Cost: {formatCost(msgCost)}
                                        </span>
                                    </div>
                                    <div className="mt-1 text-[10px] text-gray-400 italic">
                                        * Per-message cost from billing record
                                    </div>
                                </div>

                                {/* Campaign-level summary */}
                                <div className="mt-2 pt-2 border-t border-blue-100">
                                    <div className="font-semibold mb-1 text-gray-700 dark:text-gray-200">Campaign Summary</div>
                                    <div className="flex flex-wrap gap-1">
                                        <span className="px-2 py-0.5 rounded-full bg-blue-50 text-blue-600 border border-blue-200 font-semibold text-[10px]">
                                            Total: {formatCost(row.total_cost)}
                                        </span>
                                        <span className="px-2 py-0.5 rounded-full bg-green-50 text-green-600 border border-green-200 font-semibold text-[10px]">
                                            Net: {formatCost(row.net_cost)}
                                        </span>
                                        {Number(row.total_refunded) > 0 && (
                                            <span className="px-2 py-0.5 rounded-full bg-orange-50 text-orange-600 border border-orange-200 font-semibold text-[10px]">
                                                Refunded: {formatCost(row.total_refunded)}
                                            </span>
                                        )}
                                    </div>
                                    <div className="mt-1 text-[10px] text-gray-500">
                                        Billed msgs: {row.billed_messages ?? '-'} / Total msgs: {row.total_messages ?? '-'}
                                    </div>
                                </div>

                                {parsedVariables && parsedVariables.length > 0 && (
                                    <div className="mt-1">
                                        <strong>Variables:</strong> {parsedVariables.join(', ')}
                                    </div>
                                )}
                            </div>

                            {/* Error block */}
                            {isFailed && (
                                <div className="bg-red-50 border border-red-200 rounded-lg p-3 mb-3 text-[11.5px] text-red-600">
                                    <div className="font-bold mb-1">Error Details</div>
                                    <div><strong>Code:</strong> {errorCode}</div>
                                    <div><strong>Reason:</strong> {errorReason}</div>
                                </div>
                            )}

                            {/* WhatsApp Mobile Frame */}
                            <div style={{ border: '8px solid #111', borderRadius: 40, overflow: 'hidden', width: 300, height: 560, display: 'flex', flexDirection: 'column', background: '#ece5dd', margin: '0 auto' }}>

                                {/* Status bar */}
                                <div style={{ background: '#00816a', padding: '4px 10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <span style={{ color: '#fff', fontSize: 11, fontWeight: 700 }}>11:20</span>
                                    <div style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
                                        <svg fill="#fff" width="13" height="13" viewBox="0 0 24 24"><path d="M1 9l2 2c4.97-4.97 13.03-4.97 18 0l2-2C16.93 2.93 7.08 2.93 1 9zm8 8l3 3 3-3c-1.65-1.66-4.34-1.66-6 0zm-4-4l2 2c2.76-2.76 7.24-2.76 10 0l2-2C15.14 9.14 8.87 9.14 5 13z" /></svg>
                                        <svg fill="#fff" width="13" height="13" viewBox="0 0 24 24"><path d="M2 22h20V2L2 22z" /></svg>
                                        <svg fill="#fff" width="13" height="13" viewBox="0 0 24 24"><path d="M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4z" /></svg>
                                    </div>
                                </div>

                                {/* WA Header bar */}
                                <div style={{ background: '#00816a', padding: '8px 10px', display: 'flex', alignItems: 'center', gap: 8 }}>
                                    <span style={{ color: '#fff', fontSize: 18, lineHeight: 1 }}>&#8592;</span>
                                    <div style={{ width: 34, height: 34, borderRadius: '50%', background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                        <svg viewBox="0 0 24 24" width="20" height="20" fill="#00816a">
                                            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
                                            <path d="M12 0C5.373 0 0 5.373 0 12c0 2.106.548 4.083 1.504 5.797L0 24l6.321-1.484A11.94 11.94 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.818 9.818 0 01-5.006-1.366l-.36-.213-3.737.878.892-3.648-.234-.374A9.818 9.818 0 1112 21.818z" />
                                        </svg>
                                    </div>
                                    <div>
                                        <div style={{ color: '#fff', fontSize: 13, fontWeight: 600 }}>Template Preview</div>
                                        <div style={{ color: 'rgba(255,255,255,.75)', fontSize: 10 }}>Business Account</div>
                                    </div>
                                    <div style={{ marginLeft: 'auto', color: '#fff', fontSize: 18 }}>&#8942;</div>
                                </div>

                                {/* Chat body */}
                                <div style={{ flex: 1, overflowY: 'auto', padding: '10px 8px', background: '#e5ddd5' }}>
                                    <div style={{ background: '#fff', borderRadius: '0 8px 8px 8px', padding: '8px 10px', maxWidth: '90%', boxShadow: '0 1px 2px rgba(0,0,0,.15)', fontSize: 12, color: '#303030', lineHeight: 1.5 }}>
                                        {headerMedia && (
                                            <div style={{ background: '#d0d0d0', borderRadius: 6, height: 70, display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 7, color: '#666', fontSize: 11 }}>
                                                [{headerMedia.format} Header]
                                            </div>
                                        )}
                                        <div style={{ fontSize: 12.5, color: '#111', whiteSpace: 'pre-line', lineHeight: 1.55 }}>
                                            {bodyText || '(No message content)'}
                                        </div>
                                        {footerText && (
                                            <div style={{ fontSize: 10.5, color: '#999', marginTop: 5, borderTop: '1px solid #f0f0f0', paddingTop: 4 }}>{footerText}</div>
                                        )}
                                        <div style={{ textAlign: 'right', fontSize: 10, marginTop: 3, display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 2 }}>
                                            <span style={{ color: '#999' }}>
                                                {new Date(row.created_at || Date.now()).toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', hour12: true })}
                                            </span>
                                            {status === 'sent'      && <span style={{ color: '#999', fontSize: 11 }}>✓</span>}
                                            {status === 'delivered' && <span style={{ color: '#999', fontSize: 11 }}>✓✓</span>}
                                            {status === 'read'      && <span style={{ color: tickColor, fontSize: 11 }}>✓✓</span>}
                                        </div>
                                    </div>

                                    {buttons.length > 0 && (
                                        <div style={{ background: '#fff', borderRadius: 8, marginTop: 5, overflow: 'hidden', boxShadow: '0 1px 2px rgba(0,0,0,.15)', maxWidth: '90%' }}>
                                            {buttons.map((b, idx) => (
                                                <div key={idx} style={{ textAlign: 'center', borderTop: idx > 0 ? '1px solid #e9ecef' : 'none', padding: '7px 0', color: '#3f7fca', fontSize: 12, fontWeight: 600, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}>
                                                    {b.type === 'PHONE_NUMBER' && <span>📞</span>}
                                                    {b.type === 'URL'          && <span>🔗</span>}
                                                    {b.type === 'QUICK_REPLY'  && <span>↩</span>}
                                                    {b.text || ''}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>

                                {/* Footer input */}
                                <div style={{ background: '#f0f0f0', padding: '7px 8px', display: 'flex', gap: 7, alignItems: 'center' }}>
                                    <div style={{ flex: 1, background: '#fff', borderRadius: 20, padding: '6px 12px', fontSize: 11.5, color: '#aaa', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <span>😊 &nbsp;Enter your message</span>
                                        <span>📎 📷</span>
                                    </div>
                                    <div style={{ width: 34, height: 34, borderRadius: '50%', background: '#00816a', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: 14 }}>🎤</div>
                                </div>
                            </div>

                        </div>
                    )}
                </div>
            </div>
        </>
    );
}

// ── Main Component ─────────────────────────────────────────────────────────
function DeliveryReport() {
    const [showFilter,    setShowFilter]    = useState(false);
    const [fNumber,       setFNumber]       = useState('');
    const [fTemplateType, setFTemplateType] = useState('');
    const [fStatus,       setFStatus]       = useState('');

    const [allData,  setAllData]  = useState([]);
    const [filtered, setFiltered] = useState([]);
    const [loading,  setLoading]  = useState(false);
    const [error,    setError]    = useState('');

    const [currentPage, setCurrentPage] = useState(1);
    const [perPage,     setPerPage]     = useState(10);
    const [sortField,   setSortField]   = useState('');
    const [sortAsc,     setSortAsc]     = useState(true);

    const [templates,      setTemplates]      = useState([]);
    const [previewRow,     setPreviewRow]     = useState(null);
    const [previewOpen,    setPreviewOpen]    = useState(false);
    const [previewLoading, setPreviewLoading] = useState(false);

    const templateCacheRef    = useRef(null);
    // Cache: campaign_id → { message_id → cost }
    const msgCostCacheRef     = useRef({});

    // Pagination
    const start      = (currentPage - 1) * perPage;
    const end        = Math.min(start + perPage, filtered.length);
    const pageData   = filtered.slice(start, end);
    const totalPages = Math.ceil(filtered.length / perPage) || 1;

    const { userId, token } = getUserIdFromToken();

    // ── Fetch templates (cached) ─────────────────────────────────────────
    const fetchTemplates = useCallback(async () => {
        if (templateCacheRef.current) return templateCacheRef.current;
        try {
            const res  = await fetch(`${API_URL}/auth/templates/${WABA_ID}`, { credentials: 'include' });
            const data = await res.json();
            const list = Array.isArray(data) ? data : (data.data || []);
            templateCacheRef.current = list;
            setTemplates(list);
            return list;
        } catch (e) {
            console.warn('Templates not loaded:', e);
            return [];
        }
    }, []);

    // ── Fetch per-message costs for a campaign (cached) ──────────────────
    // Returns a Map: message_id → cost (number)
    const fetchMsgCostByCampaign = useCallback(async (campaignId) => {
        const key = String(campaignId);
        if (msgCostCacheRef.current[key]) return msgCostCacheRef.current[key];
        try {
            const res  = await fetch(`${API_URL}/auth/cost-by-message`, {
                method:  'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ campaign_id: campaignId }),
            });
            const json = await res.json();
            const costMap = {};
            if (json.success && Array.isArray(json.data)) {
                json.data.forEach(({ message_id, cost }) => {
                    if (message_id) costMap[message_id] = Number(cost) || 0;
                });
            }
            msgCostCacheRef.current[key] = costMap;
            return costMap;
        } catch (e) {
            console.warn(`cost-by-message failed for campaign ${campaignId}:`, e);
            return {};
        }
    }, [token]);

    // ── Parse template name + body variables from content JSON ───────────
    function parseContent(msg) {
        let templateName = '';
        let templateVariables = [];
        if (msg.content) {
            try {
                const c = typeof msg.content === 'string' ? JSON.parse(msg.content) : msg.content;
                templateName = c.name || '';
                const bodyComp = (c.components || []).find(x => x.type === 'body');
                if (bodyComp) {
                    templateVariables = (bodyComp.parameters || []).map(p => p.text || '');
                }
            } catch { /* ignore */ }
        }
        return { templateName, templateVariables };
    }

    // ── Main fetch ────────────────────────────────────────────────────────
    // Flow:
    //   1. Fetch cost-summary  → campaignMap (campaign-level totals, keyed by campaign_id)
    //   2. Fetch phone_number_ids for this user
    //   3. Fetch all messages per phone_number_id
    //   4. Collect unique campaign_ids from messages
    //   5. For each unique campaign_id call cost-by-message → build msgCostMap (message_id → cost)
    //   6. Enrich every message: attach campaign summary + per-message cost
    const fetchData = useCallback(async () => {
        if (!userId) return;
        setLoading(true);
        setError('');
        try {
            await fetchTemplates();

            // ── Step 1: Campaign-level cost summary ───────────────────────
            const reportRes  = await fetch(
                `${API_URL}/auth/campaigns/cost-summary?client_id=${userId}`,
                { credentials: 'include', headers: { Authorization: `Bearer ${token}` } }
            );
            const reportJson = await reportRes.json();
            const reportList = Array.isArray(reportJson.data) ? reportJson.data : [];

            // campaignMap: campaign_id (string) → campaign summary object
            const campaignMap = {};
            reportList.forEach(c => {
                campaignMap[String(c.campaign_id)] = c;
            });

            // ── Step 2: Get phone_number_ids for this user ────────────────
            const phoneRes  = await fetch(
                `${API_URL}/auth/phone_number_id?userId=${encodeURIComponent(userId)}`,
                { credentials: 'include', headers: { Authorization: `Bearer ${token}` } }
            );
            const phoneData = await phoneRes.json();
            const phoneNumberIds = (phoneData.success && Array.isArray(phoneData.phone_number_ids))
                ? phoneData.phone_number_ids : [];

            if (!phoneNumberIds.length) {
                setAllData([]); setFiltered([]); setLoading(false);
                return;
            }

            // ── Step 3: Fetch messages for each phone_number_id ───────────
            const msgArrays = await Promise.all(
                phoneNumberIds.map(async (pid) => {
                    try {
                        const res  = await fetch(
                            `${API_URL}/auth/messages?phone_number_id=${encodeURIComponent(pid)}`,
                            { credentials: 'include', headers: { Authorization: `Bearer ${token}` } }
                        );
                        const data = await res.json();
                        return Array.isArray(data) ? data : (Array.isArray(data?.data) ? data.data : []);
                    } catch { return []; }
                })
            );
            const allMessages = msgArrays.flat();

            // ── Step 4: Collect unique campaign_ids that have messages ─────
            // campaignMap is an object, not an array, so use Object.keys to extract campaign IDs
            const uniqueCampaignIds = Object.keys(campaignMap)
                .filter(id => id != null && id !== '');
    
            // ── Step 5: Fetch per-message cost for each campaign in parallel
            // Result: msgCostMap — message_id (wamid) → cost (number)
            const costMaps = await Promise.all(
                uniqueCampaignIds.map(cid => fetchMsgCostByCampaign(cid))
            );
            // Merge all campaign cost maps into one flat map keyed by message_id
            const msgCostMap = Object.assign({}, ...costMaps);

            // ── Step 6: Enrich every message ──────────────────────────────
            const enriched = allMessages.map(msg => {
                const campaign = campaignMap[String(msg.campaign_id)] || {};
                const { templateName, templateVariables } = parseContent(msg);

                const rawPhone = msg.to_number || msg.from_number || msg.recipient || msg.phone || '';

                // Per-message cost: look up by message_id (wamid)
                const wamid      = msg.message_id || msg.wamid || '';
                const msgCost    = wamid ? (msgCostMap[wamid] ?? null) : null;

                return {
                    ...msg,

                    // ── Phone ──────────────────────────────────────────────
                    phone_number_display: formatPhone(rawPhone),

                    // ── Status ─────────────────────────────────────────────
                    status: msg.status || msg.message_status || msg.delivery_status || 'pending',

                    // ── Template ───────────────────────────────────────────
                    template_name: templateName || campaign.template_name || msg.template_name || '-',
                    template_type: (campaign.template_type === 'All' ? '' : campaign.template_type)
                                   || msg.template_type || '-',

                    // ── Campaign ───────────────────────────────────────────
                    campaign_name:   campaign.campaign_name || msg.campaign_name || '-',
                    campaign_status: campaign.status        || '-',

                    // ── Campaign-level cost totals (from cost-summary) ─────
                    total_cost:      campaign.total_cost      ?? null,
                    net_cost:        campaign.net_cost        ?? null,
                    total_refunded:  campaign.total_refunded  ?? null,
                    billed_messages: campaign.billed_messages ?? null,
                    total_messages:  campaign.total_messages  ?? null,

                    // ── Per-message cost (from cost-by-message) ────────────
                    message_cost: msgCost,

                    // ── Misc ───────────────────────────────────────────────
                    variables:      templateVariables,
                    interface_type: msg.interface || msg.channel || 'Web',
                    received_at:    msg.created_at,
                };
            });

            // Sort newest first
            enriched.sort((a, b) => new Date(b.received_at) - new Date(a.received_at));

            setAllData(enriched);
            setFiltered(enriched);
            setCurrentPage(1);

        } catch (e) {
            console.error(e);
            setError('Failed to load delivery data.');
        } finally {
            setLoading(false);
        }
    }, [userId, token, fetchTemplates, fetchMsgCostByCampaign]);

    useEffect(() => { fetchData(); }, [fetchData]);

    // ── Filter ───────────────────────────────────────────────────────────
    const applyFilter = () => {
        let d = [...allData];
        if (fNumber)       d = d.filter(r => (r.phone_number_display || '').includes(fNumber));
        if (fTemplateType) d = d.filter(r => (r.template_type || '').toLowerCase() === fTemplateType.toLowerCase());
        if (fStatus)       d = d.filter(r => (r.status || '').toLowerCase().includes(fStatus.toLowerCase()));
        if (sortField)     d = sortList(d, sortField, sortAsc);
        setFiltered(d);
        setCurrentPage(1);
    };

    const clearFilter = () => {
        setFNumber(''); setFTemplateType(''); setFStatus('');
        setFiltered(sortField ? sortList([...allData], sortField, sortAsc) : [...allData]);
        setCurrentPage(1);
    };

    // ── Sort ─────────────────────────────────────────────────────────────
    const sortList = (list, field, asc) => [...list].sort((a, b) => {
        const va = (a[field] ?? '').toString().toLowerCase();
        const vb = (b[field] ?? '').toString().toLowerCase();
        return asc ? va.localeCompare(vb) : vb.localeCompare(va);
    });

    const handleSort = (field) => {
        const newAsc = sortField === field ? !sortAsc : true;
        setSortField(field); setSortAsc(newAsc);
        setFiltered(prev => sortList(prev, field, newAsc));
        setCurrentPage(1);
    };

    // ── Open preview ─────────────────────────────────────────────────────
    const openPreview = async (row) => {
        setPreviewRow(row);
        setPreviewOpen(true);
        setPreviewLoading(true);
        const list = await fetchTemplates();
        setTemplates(list);
        setPreviewLoading(false);
    };

    // ── CSV Download ─────────────────────────────────────────────────────
    const handleDownload = () => {
        const headers = [
            'Received Date', 'Channel', 'Number', 'Status', 'Message Id',
            'Sent On', 'Delivered On', 'Read On',
            'Campaign Name', 'Template Name', 'Template Type', 'Interface',
            'Message Cost',                           // ← per-message cost
            'Campaign Total Cost', 'Campaign Net Cost', 'Campaign Refunded',
            'Billed Messages', 'Total Messages',
            'Variables', 'Error Code', 'Error Reason',
        ];
        const rows = filtered.map(r => {
            const st = (r.status || '').toLowerCase();
            return [
                r.received_at ? new Date(r.received_at).toLocaleString() : '',
                'WhatsApp',
                r.phone_number_display || '',
                r.status || '',
                r.message_id || r.wamid || '',
                r.sent_at      ? fmtDt(r.sent_at)      : (st !== 'pending' ? fmtDt(r.created_at) : ''),
                r.delivered_at ? fmtDt(r.delivered_at) : (['delivered','read'].includes(st) ? fmtDt(r.updated_at || r.created_at) : ''),
                r.read_at      ? fmtDt(r.read_at)      : (st === 'read' ? fmtDt(r.updated_at || r.created_at) : ''),
                r.campaign_name  || '',
                r.template_name  || '',
                r.template_type  || '',
                r.interface_type || 'Web',
                r.message_cost   != null ? Number(r.message_cost).toFixed(3)   : '',   // per-msg cost
                r.total_cost     != null ? Number(r.total_cost).toFixed(3)     : '',
                r.net_cost       != null ? Number(r.net_cost).toFixed(3)       : '',
                r.total_refunded != null ? Number(r.total_refunded).toFixed(3) : '',
                r.billed_messages ?? '',
                r.total_messages  ?? '',
                Array.isArray(r.variables) ? r.variables.join('; ') : '',
                r.error_code   || r.errorCode   || r.error || '',
                r.error_reason || r.errorReason || r.error_message || '',
            ];
        });
        const csv  = [headers, ...rows].map(row => row.map(v => `"${(v ?? '').toString().replace(/"/g, '""')}"`).join(',')).join('\n');
        const link = Object.assign(document.createElement('a'), {
            href:     URL.createObjectURL(new Blob([csv], { type: 'text/csv' })),
            download: 'delivery_report.csv',
        });
        link.click();
    };

    // ── Column config ─────────────────────────────────────────────────────
    const columns = [
        { label: 'Received Date',    field: 'received_at' },
        { label: 'Channel',          field: null },
        { label: 'Number',           field: 'phone_number_display' },
        { label: 'Status',           field: 'status' },
        { label: 'Message Id',       field: null },
        { label: 'Acknowledgement',  field: null },
        { label: 'Interface / Type', field: 'interface_type' },
        { label: 'Cost',             field: 'message_cost' },   // now sortable
        { label: 'Error Details',    field: null },
        { label: 'Action',           field: null },
    ];

    return (
        <>
            <MobilePreviewOffcanvas
                open={previewOpen}
                onClose={() => setPreviewOpen(false)}
                row={previewRow}
                templates={templates}
                previewLoading={previewLoading}
            />

            {/* Top bar */}
            <div className="w-full flex items-center justify-between mb-2">
                <p className="text-[12px] text-gray-500 dark:text-gray-400">
                    Total: <span className="font-bold text-[#37715d]">{allData.length}</span> messages
                </p>
                <div className="flex gap-2">
                    <button
                        onClick={fetchData}
                        className="flex items-center justify-center border border-[#37715d] rounded-lg p-2 text-[#37715d] gap-1 hover:bg-[#37715d] hover:text-white transition-colors"
                    >
                        <TbReload className="text-[13px]" />
                        <span className="text-[12px] font-bold">Refresh</span>
                    </button>
                    <button
                        onClick={handleDownload}
                        className="flex items-center justify-center border border-[#3f7fca] rounded-lg p-2 text-[#3f7fca] gap-1 hover:bg-[#3f7fca] hover:text-white transition-colors"
                    >
                        <FaDownload className="text-[12px]" />
                        <span className="text-[12px] font-bold">Download</span>
                    </button>
                </div>
            </div>

            {/* Filter toggle */}
            <div
                onClick={() => setShowFilter(p => !p)}
                className="w-full flex justify-between px-4 py-2 bg-[#e0e0e04b] rounded-t-[20px] cursor-pointer"
            >
                <div className="flex items-center text-[#576071] font-semibold gap-3 dark:text-white text-[12px]">
                    <RiCollapseDiagonalLine /> Filter Records
                </div>
                <div className="flex items-center text-[#576071] dark:text-white">
                    {showFilter ? <IoIosArrowDown /> : <IoIosArrowUp />}
                </div>
            </div>

            {/* Filter panel */}
            {showFilter && (
                <div className="bg-[#edf1f5] py-2 px-4 w-full dark:bg-[#121519]">
                    <div className="w-full flex flex-wrap gap-2">
                        <div className="w-full sm:w-[48%] lg:w-[19%] flex flex-col gap-1">
                            <label className="text-[#000] text-[12px] font-semibold dark:text-white">Number</label>
                            <input
                                value={fNumber}
                                onChange={e => setFNumber(e.target.value)}
                                className="text-[#454546] border-[#d4cfcf] border rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-white"
                                type="text" placeholder="+91..."
                            />
                        </div>
                        <div className="w-full sm:w-[48%] lg:w-[19%] flex flex-col gap-1">
                            <label className="text-[#000] text-[12px] font-semibold dark:text-white">Template Type</label>
                            <select
                                value={fTemplateType}
                                onChange={e => setFTemplateType(e.target.value)}
                                className="text-[#454546] border-[#d4cfcf] border rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-white"
                            >
                                <option value="">Select Template Type</option>
                                <option value="marketing">Marketing</option>
                                <option value="utility">Utility</option>
                                <option value="authentication">Authentication</option>
                            </select>
                        </div>
                        <div className="w-full sm:w-[48%] lg:w-[19%] flex flex-col gap-1">
                            <label className="text-[#000] text-[12px] font-semibold dark:text-white">Delivery Status</label>
                            <select
                                value={fStatus}
                                onChange={e => setFStatus(e.target.value)}
                                className="text-[#454546] border-[#d4cfcf] border rounded-md text-[12px] font-semibold px-2 py-2 outline-none dark:bg-[#121519] dark:text-white"
                            >
                                <option value="">All Status</option>
                                <option value="pending">Pending</option>
                                <option value="sent">Sent</option>
                                <option value="delivered">Delivered</option>
                                <option value="read">Read</option>
                                <option value="failed">Failed</option>
                            </select>
                        </div>
                        <div className="w-full sm:w-[48%] lg:w-[19%] flex items-center gap-1 mt-4">
                            <button onClick={applyFilter} className="flex items-center justify-center border border-[#37715d] rounded-lg p-2 text-[#37715d] gap-2 hover:bg-[#37715d] hover:text-white w-full sm:w-auto transition-colors">
                                <FaFilter /><span className="text-[12px] font-bold">Filter</span>
                            </button>
                            <button onClick={clearFilter} className="flex items-center justify-center border border-[#3f7fca] rounded-lg p-2 text-[#3f7fca] gap-2 hover:bg-[#3f7fca] hover:text-white w-full sm:w-auto transition-colors">
                                <TbReload /><span className="text-[12px] font-bold">Clear Filter</span>
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Error */}
            {error && (
                <div className="w-full bg-red-50 border border-red-200 text-red-600 text-[12px] px-4 py-2 rounded my-2">
                    {error}
                </div>
            )}

            {/* Table */}
            <div className="overflow-x-auto">
                <table className="w-full border border-[#dee2e6] border-collapse">
                    <thead>
                        <tr>
                            {columns.map(col => (
                                <th key={col.label} className="p-1 border border-[#dee2e6] bg-[#f6f9fc] dark:bg-[#1a1f24]">
                                    <div className="flex justify-between items-center gap-2">
                                        <span className="text-[11px] text-[#576071] dark:text-white font-semibold whitespace-nowrap">{col.label}</span>
                                        {col.field && (
                                            <button
                                                type="button"
                                                className="text-gray-400 hover:text-black bg-transparent border-none cursor-pointer"
                                                onClick={() => handleSort(col.field)}
                                            >
                                                <TbArrowsSort />
                                            </button>
                                        )}
                                    </div>
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr className="bg-[#f6f9fc] dark:bg-[#121519]">
                                <td colSpan={columns.length} className="py-8 text-center">
                                    <div className="flex items-center justify-center gap-2 text-[12px] text-gray-400">
                                        <div className="w-4 h-4 border-2 border-[#37715d] border-t-transparent rounded-full animate-spin" />
                                        Loading delivery data...
                                    </div>
                                </td>
                            </tr>
                        ) : pageData.length === 0 ? (
                            <tr className="bg-[#f6f9fc] dark:bg-[#121519]">
                                <td colSpan={columns.length} className="py-8 text-[12px] text-gray-400 text-center">No data found</td>
                            </tr>
                        ) : (
                            pageData.map((row, i) => {
                                const status      = (row.status || '').toLowerCase();
                                const isFailed    = status === 'failed';
                                const errorCode   = row.error_code || row.errorCode || row.error || '';
                                const errorReason = row.error_reason || row.errorReason || row.error_message || '';
                                const msgId       = row.message_id || row.wamid || '-';

                                const sentOn     = row.sent_at
                                    ? fmtDt(row.sent_at)
                                    : (status !== 'pending' ? fmtDt(row.created_at) : 'N/A');
                                const deliveryOn = row.delivered_at
                                    ? fmtDt(row.delivered_at)
                                    : (['delivered','read'].includes(status) ? fmtDt(row.updated_at || row.created_at) : 'N/A');
                                const readOn     = row.read_at
                                    ? fmtDt(row.read_at)
                                    : (status === 'read' ? fmtDt(row.updated_at || row.created_at) : 'N/A');

                                const recvDate = row.received_at
                                    ? new Date(row.received_at).toLocaleString('en-IN', {
                                        day: '2-digit', month: 'short', year: 'numeric',
                                        hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true,
                                      })
                                    : '-';

                                return (
                                    <tr
                                        key={row.id || i}
                                        className="odd:bg-white even:bg-[#edf1f5] dark:odd:bg-[#121519] dark:even:bg-[#1a1f24] hover:bg-[#e8f0fa] dark:hover:bg-[#2a2f35] transition-colors"
                                    >
                                        {/* Received Date */}
                                        <td className="p-1 text-[11px] border border-[#dee2e6] dark:text-white text-gray-400 whitespace-nowrap">{recvDate}</td>

                                        {/* Channel */}
                                        <td className="p-1 text-[11px] border border-[#dee2e6] dark:text-white">
                                            <span className="flex items-center gap-1">
                                                <span className="w-2 h-2 rounded-full bg-green-500 inline-block" />
                                                WhatsApp
                                            </span>
                                        </td>

                                        {/* Number */}
                                        <td className="p-1 text-[11px] border border-[#dee2e6] dark:text-white font-mono">
                                            {row.phone_number_display}
                                        </td>

                                        {/* Status */}
                                        <td className="p-1 text-[11px] border border-[#dee2e6]">
                                            <StatusBadge status={row.status} />
                                        </td>

                                        {/* Message ID */}
                                        <td className="p-1 text-[10px] border border-[#dee2e6] dark:text-white max-w-[140px] overflow-hidden text-ellipsis whitespace-nowrap" title={msgId}>
                                            {msgId}
                                        </td>

                                        {/* Acknowledgement */}
                                        <td className="p-1 text-[10px] border border-[#dee2e6] dark:text-white leading-snug">
                                            <div>Sent On: {sentOn}</div>
                                            <div>Delivery On: {deliveryOn}</div>
                                            <div>Read On: {readOn}</div>
                                        </td>

                                        {/* Interface / Type */}
                                        <td className="p-1 text-[10px] border border-[#dee2e6] dark:text-white leading-snug capitalize">
                                            <div>Interface: {row.interface_type || 'Web'}</div>
                                            <div>Type: {row.template_type || '-'}</div>
                                            <div>Template: {row.template_name || '-'}</div>
                                        </td>

                                        {/* Cost — per-message from cost-by-message API */}
                                        <td className="p-1 text-[11px] border border-[#dee2e6] dark:text-white">
                                            <div className="flex flex-col gap-0.5">
                                                {/* Per-message cost (primary) */}
                                                <span className="px-2 py-0.5 rounded-full text-[10px] font-semibold text-black whitespace-nowrap">
                                                    {formatCost(row.message_cost || 0.00)}
                                                </span>
                                                
                                                {Number(row.total_refunded) > 0 && (
                                                    <span className="px-2 py-0.5 rounded-full text-[10px] font-semibold border bg-orange-50 text-orange-500 border-orange-200 whitespace-nowrap">
                                                        Refund: {formatCost(row.total_refunded)}
                                                    </span>
                                                )}
                                            </div>
                                        </td>

                                        {/* Error Details */}
                                        <td className="p-1 text-[11px] border border-[#dee2e6]">
                                            {isFailed ? (
                                                <div className="text-red-500 text-[10px]">
                                                    <div><span className="font-semibold">Code:</span> {errorCode || '-'}</div>
                                                    <div><span className="font-semibold">Reason:</span> {errorReason || '-'}</div>
                                                </div>
                                            ) : (
                                                <span className="text-gray-400 text-[10px]">N/A</span>
                                            )}
                                        </td>

                                        {/* Action */}
                                        <td className="p-1 text-[11px] border border-[#dee2e6]">
                                            <button
                                                className="text-[#3f7fca] border border-[#3f7fca] rounded px-2 py-0.5 text-[10px] font-bold hover:bg-[#3f7fca] hover:text-white transition-colors"
                                                onClick={() => openPreview(row)}
                                            >
                                                View
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })
                        )}
                    </tbody>
                </table>
            </div>

            {/* Pagination */}
            <div className="flex flex-col md:flex-row md:justify-between w-full mt-2 gap-2">
                <div className="flex items-center mt-2 space-x-2">
                    <label className="text-[11px] text-[#3f7fc8]">
                        Show
                        <select
                            className="mx-1 px-1 py-0.5 border border-gray-300 rounded text-[11px] outline-none"
                            style={{ minWidth: 52 }}
                            value={perPage}
                            onChange={e => { setPerPage(parseInt(e.target.value)); setCurrentPage(1); }}
                        >
                            <option value={10}>10</option>
                            <option value={20}>20</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                        </select>
                        entries
                    </label>
                </div>

                <p className="text-[11px] text-[#3f7fc8] mt-2">
                    Showing {filtered.length === 0 ? 0 : start + 1} to {end} of {filtered.length} records
                </p>

                <div className="flex items-center mt-2 space-x-1">
                    <button
                        disabled={currentPage === 1}
                        onClick={() => setCurrentPage(p => p - 1)}
                        className="px-3 py-1 text-[11px] bg-gray-200 rounded disabled:opacity-50 hover:bg-gray-300 transition"
                    >Prev</button>

                    {Array.from({ length: Math.min(5, totalPages) }, (_, idx) => {
                        const p = Math.max(1, Math.min(currentPage - 2, totalPages - 4)) + idx;
                        if (p < 1 || p > totalPages) return null;
                        return (
                            <button
                                key={p}
                                onClick={() => setCurrentPage(p)}
                                className={`px-3 py-1 text-[11px] rounded transition ${p === currentPage ? 'bg-[#3f7fca] text-white' : 'bg-gray-200 hover:bg-gray-300'}`}
                            >{p}</button>
                        );
                    })}

                    <button
                        disabled={currentPage >= totalPages}
                        onClick={() => setCurrentPage(p => p + 1)}
                        className="px-3 py-1 text-[11px] bg-gray-200 rounded disabled:opacity-50 hover:bg-gray-300 transition"
                    >Next</button>
                </div>
            </div>
        </>
    );
}

export default DeliveryReport;